// hooks/useOrderTracking.js
import { useQuery } from "@tanstack/react-query";
import apiClient from "../api/axios";

const useOrderTracking = (orderId, enabled = false) => {
  return useQuery({
    queryKey: ["order-tracking", orderId],
    queryFn: async () => {
      const res = await apiClient.get(
        `/admin/orders/${orderId}/track`
      );
      return res.data;
    },
    enabled: !!orderId && enabled,
  });
};

export default useOrderTracking;
